import { AiOutlineCloseCircle } from "react-icons/ai";
import { useStores } from "../../../store";
import { useObserver } from "mobx-react";
import { useEffect, useRef } from "react";
import { apiGet, apiPostPut } from "../../../api/api_methods";
import {
  getLabels,
  updateLabelsForCandidates,
} from "../../../api/recruiterLabelsApi";
import { toJS } from "mobx";
import { useNavigate } from "react-router-dom";
import LabelPopup from "./LabelPopup";

export default function ApplicantLabelPopup(props) {
  const navigate = useNavigate();
  const query = new URLSearchParams(window.location.search);
  const page = Number(query.get("page")) || 0;
  const { LabelStore, RecuiterStore, MockStore, PopupStore } = useStores();
  const bodyRef = useRef({
    id: LabelStore?.ApplicantId,
    section:
      LabelStore?.section === "jobPost" ? "application" : LabelStore?.section,
    add: [],
    remove: [],
  });

  useEffect(() => {
    bodyRef.current.id = LabelStore?.ApplicantId;
    bodyRef.current.section =
      LabelStore?.section === "jobPost" ? "application" : LabelStore?.section;
  }, [LabelStore?.ApplicantId, LabelStore?.section]);

  useEffect(() => {
    // jobPostsData();

    if (!LabelStore.applicationLabelFetch) {
      fetchlabelsData().then(() => {
        LabelStore.setApplicationLabelFetch(true);
      });

      console.log("body: ", bodyRef.current);
    }
  }, []);
  const fetchlabelsData = async () => {
    if (!LabelStore.applicationLabelFetch) {
      try {
        const response = await getLabels();
        if (response.status === 200 && response.body.success) {
          console.log(response.body.data);
          response.body.data.map((item, index) => {
            console.log(item.color);
          });
          // setFetchedLabels(response.body.data);
          LabelStore.setLabelsList(response.body.data);
          LabelStore.setSelctedLabel(LabelStore.labels_list[0]._id);
          LabelStore.setSelectedLebelValues(LabelStore.labels_list[0]);
          LabelStore.setApplicationLabelFetch(true);
        } else {
          console.log(`Error fetching job data: ${response.body.message}`);
        }
      } catch (error) {
        // setError(`Error fetching job data: ${error.message}`);
        console.error("Error fetching job data:", error); // Log the detailed error
      }
    }
  };
  const updateTable = () => {
    console.log("body: ", bodyRef.current);

    const postLabels = async () => {
      try {
        console.log(" injected body: ", bodyRef.current);
        LabelStore.setLoader(true);

        const response = await updateLabelsForCandidates(bodyRef.current);

        if (response.status === 200 && response.body.success) {
          if (LabelStore.section === "resumeSorting") {
            RecuiterStore.fetchapplicants();
            RecuiterStore.fetchResumeScore(page * 10);
            LabelStore.setLoader(false);
            return;
          }
          RecuiterStore.fetchapplicants();
          await RecuiterStore.fetchApplicantDetails(bodyRef.current?.id);
          LabelStore?.setreportScreenRefresher();
          console.log("report set");
          console.log("body: ", bodyRef.current);
          console.log("label updated", response.body);
          if (LabelStore.section == "resumeSorting") {
            RecuiterStore.fetchapplicants();
            return;
          }
          if (LabelStore.currentSection == "redirect") {
            console.log("this is ID --> ", LabelStore.applicant_id_mock);
            await MockStore.getReport(LabelStore.applicant_id_mock);
            // console.log("navigating...")
            // console.log(`/company/mocktest-applicants/${LabelStore.applicant_id_mock}?mocktestId=${LabelStore.MockTestId}`)
            // console.log(LabelStore.MockTestId)
            // navigate(`/company/mocktest-applicants/${LabelStore.applicant_id_mock}?mocktestId=${LabelStore.MockTestId}`);
          }
        } else {
          console.log(`Error fetching job data: ${response.body.message}`);
        }
        RecuiterStore.setClientId();
        RecuiterStore.fetchapplicants();
        RecuiterStore.fetchResumeScore();

        LabelStore.setLoader2(!LabelStore.loader2);
        LabelStore.setLoader(false);

        LabelStore.setApplicantId(null);
      } catch (error) {
        console.error("Error fetching job data:", error); // Log the detailed error
        LabelStore.setLoader(false);
      }
    };
    postLabels();

    LabelStore.setApplicants(false);
    console.log("popup is set to: ", LabelStore.Applicants);
    // console.log("body: ", body);
  };

  return useObserver(() => (
    <>
      {LabelStore.Applicants ? (
        <div
          onClick={() => {
            LabelStore.setApplicants(false);
            LabelStore.setApplicantId(null);
          }}
          className="fixed inset-0 z-50 w-screen h-screen bg-black backdrop-filter backdrop-blur-sm bg-opacity-0"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="absolute  inset-0 bg-bg3 z-50 flex flex-col rounded-3xl border  items-center md:w-[20%] lg:w-[20%] w-[90%] h-fit  m-auto overflow-y-scroll no-scrollbar"
          >
            <AiOutlineCloseCircle
              className="absolute text-xl cursor-pointer top-2 right-2"
              onClick={() => {
                //   PopupStore.setLabelPopup(false);
                LabelStore.setApplicants(false);
                LabelStore.setApplicantId(null);
              }}
            />
            <p className="text-3xl  mt-10 text-primary">Tags </p>
            <p className="text-xl mt-4 mx-auto text-gray-500">
              {/* Click on the check box to add / Remove from the label{" "} */}
            </p>
            <div
              className="col w-[80%] min-h-[20vh] max-h-[40vh] mb-[10vh] overflow-y-auto no-scrollbar  "
              onClick={() =>
                console.log(
                  toJS(LabelStore?.labels_list),
                  "this is lables list",
                )
              }
            >
              {LabelStore?.labels_list?.length > 0 ? (
                LabelStore?.labels_list?.map(
                  (item, index) =>
                    !item.isDeleted && (
                      <div key={index} className=" flex items-center">
                        {LabelStore?.ApplicantLabelArray?.includes(item._id) ? (
                          <input
                            type="checkbox"
                            style={{
                              borderColor: item?.color,
                              accentColor: item.color,
                              cursor: "pointer",
                            }}
                            className="w-5 h-5 mt-2"
                            defaultChecked={LabelStore?.ApplicantLabelArray?.includes(
                              item._id,
                            )}
                            onChange={(e) => {
                              const body = bodyRef.current;
                              if (e.target.checked) {
                                if (!body.add.includes(item._id)) {
                                  body.add.push(item._id);
                                }
                                body.remove = body.remove.filter(
                                  (id) => id !== item._id,
                                );
                              } else {
                                body.add = body.add.filter(
                                  (id) => id !== item._id,
                                );
                                if (!body.remove.includes(item._id)) {
                                  body.remove.push(item._id);
                                }
                              }
                              console.log("body: ", body);
                            }}
                          />
                        ) : (
                          <input
                            type="checkbox"
                            style={{
                              borderColor: item?.color,
                              accentColor: item.color,
                              cursor: "pointer",
                            }}
                            className="w-5 h-5 mt-2"
                            defaultChecked={LabelStore?.ApplicantLabelArray?.includes(
                              item._id,
                            )}
                            onChange={(e) => {
                              const body = bodyRef.current;
                              if (e.target.checked) {
                                LabelStore.setApplicantColor(item.color);
                                if (!body.add.includes(item._id)) {
                                  body.add.push(item._id);
                                }
                                body.remove = body.remove.filter(
                                  (id) => id !== item._id,
                                );
                              } else {
                                body.add = body.add.filter(
                                  (id) => id !== item._id,
                                );
                                if (!body.remove.includes(item._id)) {
                                  body.remove.push(item._id);
                                }
                              }
                              console.log("body: ", body);
                            }}
                          />
                        )}
                        <p className="text-sm py-1 mt-2 px-2">{item.name}</p>
                        <div
                          type=""
                          style={{
                            backgroundColor: item?.color,
                            accentColor: item.color,
                            cursor: "pointer",
                          }}
                          className="w-5 h-5 mt-2 ml-auto outline-none  rounded-full mr-3"
                          defaultChecked={item?.color}
                          onChange={(e) => {
                            const body = bodyRef.current;
                            if (e.target.checked) {
                              if (!body.add.includes(item._id)) {
                                body.add.push(item._id);
                                console.log("body.add: ", body.add);
                                if (body.remove.includes(item._id)) {
                                  body.remove = body.remove.filter(
                                    (id) => id !== item._id,
                                  );
                                  console.log("body.remove: ", body.remove);
                                }
                              }
                            } else {
                              if (body.add.includes(item._id)) {
                                body.add = body.add.filter(
                                  (id) => id !== item._id,
                                );
                                console.log("body.add: ", body.add);
                              }
                              body.remove = body.remove.filter(
                                (id) => id !== item._id,
                              );
                              body.remove.push(item._id);
                              console.log("body.remove: ", body.remove);
                            }
                          }}
                        ></div>
                      </div>
                    ),
                )
              ) : (
                <p className=" my-10 ml-10 text-2xl">No tags found</p>
              )}
            </div>
            <div className="flex justify-between items-center absolute bottom-3 gap-10 mb-2">
              <button>
                <span
                  className="cursor-pointer opacity-50 "
                  onClick={() => PopupStore.setLabelPopup(true)}
                >
                  create a new tag
                </span>

                <LabelPopup />
              </button>
              <button
                onClick={() => updateTable()}
                className="bg-primary text-white font-semibold text-sm  px-5  py-2 mt-2 mb-1 rounded-lg"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  ));
}
